import React from 'react';
import { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import LoginBnSmall from './LoginBnSmall';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function GeneratePreview() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false); // New state to track loading

  const [userPrompt, setUserPrompt] = useState('');
  const [imageUrl, setImageUrl] = useState('https://butterpuppies.s3.us-west-1.amazonaws.com/static/banner.png');
  const [promptText, setPromptText] = useState('Welcome to Butterpuppies!');

  // Handler for input change
  const handleInputChange = (event) => {
    setUserPrompt(event.target.value);
  };

// Handler for form submission
const handleSubmit = async (event) => {
  event.preventDefault(); // Prevent default form submission behavior

  if (!userPrompt || userPrompt.trim() === '') {
    console.error('userPrompt is empty or invalid');
    return;
  }

  try {
    const response = await fetch(`${API_URL}/api/generate_image`, { // Assuming your Flask endpoint is '/generate'
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_prompt: userPrompt }), // Send user input
    });

    if (response.ok) {
      const contentType = response.headers.get('Content-Type') || '';
      if (contentType.includes('application/json')) {
        const result = await response.json();
        setImageUrl(result.image_url);
        setPromptText(result.user_prompt);
      } else {
        const errorText = await response.text();
        console.error('Unexpected response format:', errorText);
        throw new Error('Response is not JSON');
      }
    } else {
      const errorText = await response.text();
      throw new Error(`Failed to fetch: ${response.status} - ${errorText}`);
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    // Handle error (optional: update UI to reflect an error state)
  }
};


  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-6 col-sm-12">
          <div className="text-center">
            {loading ? (
              // Display placeholder while loading
              <img src="/timer.gif" alt="Loading..." className="img-fluid mb-2 mt-2" />
            ) : imageUrl ? (
              // Display the received image
              <img id="coloringpage" className="img-fluid message bot print" src={imageUrl}  alt={promptText}/>
            ) : (
              // Fallback content if no image and not loading
              <p>No image to display</p>
            )}
          </div>
        </div>
      </div>

      <div className="row justify-content-center mb-3">
            <div className="col-md-6 col-sm-12 text-center bg-success-subtle bs-success-text-emphasis pb-3 rounded">
                <div className="text-center mt-3">
                    <div id="prompt" className="message user">
                    <h4 className="mb-0">Sign in for free to enjoy unlimited access!</h4>
                    You've reached your usage limit
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%", // Optional: Ensures it spans the full width of the container
                    }} >
                      <LoginBnSmall />
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row justify-content-center mb-3">
            <div className="col-sm-3"></div>
            <div className="col-sm-6 text-center text-primary-emphasis bg-secondary-subtle pt-3 rounded">
                Never run out of fun ideas again - Add your email to join our community!
                <div className="form-outline ">
                    <form action="" method="post">
                        <p>
                            <input id="form_id" name="form_id" type="hidden" value="subscriptionform"/>
                            <input id="form_id" name="form_id" size="32" type="hidden" value="subscriptionform"/>
                            <input id="email" name="email" required="" size="32" type="text" value=""/>
                            <input className="bg-warning-subtle border-warning mt-1" id="submit" name="submit" type="submit" value="Signup"/>
                        </p>
                    </form>
                </div>
            </div>
            <div className="col-sm-3"></div>
        </div>
    </>
  );
}
